export default {"src":"/_next/static/media/chevron-down.3ad2c142.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};